import { render } from "./ComponentTrashNoData.vue?vue&type=template&id=02c7839e"
import script from "./ComponentTrashNoData.vue?vue&type=script&lang=js"
export * from "./ComponentTrashNoData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__